module.exports = __webpack_public_path__ + "img/swiper_06.df93b9d9.jpg";